import { useEffect, useState } from 'react';

const Media = ({ query, children }) => {
  const [matches, setMatches] = useState();

  useEffect(() => {
    const media = window.matchMedia(query);

    // function updateSize() {
    //     date = new Date().getTime()
    //     const debounceTime = 100

    //     setTimeout(() => {
    //       const currentDate = new Date().getTime()
    //       if (currentDate >= date + debounceTime) {
    //         setWidth(window.innerWidth)
    //       }
    //     }, debounceTime)
    //   }

    function update({ matches }) {
      setMatches(matches);
    }

    media.addEventListener('change', update);

    return () => {
      media.removeEventListener('change', update);
    };
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    setMatches(media.matches);
  }, [query]);

  return children(matches);
};

export default Media;
